module.exports = __webpack_public_path__ + "img/youtube.f430cc41.png";